



























import Vue from 'vue';

import NavBar       from '@/components/app-nav/navbar.vue';
import Breadcrumbs  from '@/components/app/breadcrumbs.vue';
import Footer       from '@/components/app/footer.vue';

export default Vue.extend({
    data() {
        return {
            showAnything: false
        }
    },
    components: {
        'nav-bar': NavBar,
        breadcrumbs: Breadcrumbs,
        'app-footer': Footer,
    },
    created() {
        setTimeout(() => {
            this.showAnything = true;
        }, 500);
    }
});
